import { apiClient, fetcher } from './apiClient';

type OrganizationSummary = {
    id: string;
    name: string;
};

const jsonHeaders = (csrfToken: string | null) => ({
    'Content-Type': 'application/json',
    'X-XSRF-TOKEN': csrfToken ?? '',
});

/**
 * Organizations a staff member can switch into. Staff only (403 otherwise).
 */
const listSwitchableOrgs = async (): Promise<OrganizationSummary[]> =>
    fetcher<OrganizationSummary[]>('api/organizations');

/**
 * Switch the session's active org context into a customer org.
 */
const switchOrg = async (csrfToken: string | null, orgId: string): Promise<void> => {
    if (csrfToken === null) return;
    await apiClient.post('api/context/switch', JSON.stringify({ org_id: orgId }), {
        headers: jsonHeaders(csrfToken),
    });
};

/**
 * Exit any switched context, returning to the user's own org.
 */
const exitContext = async (csrfToken: string | null): Promise<void> => {
    if (csrfToken === null) return;
    await apiClient.post('api/context/exit', JSON.stringify({}), {
        headers: jsonHeaders(csrfToken),
    });
};

export { listSwitchableOrgs, switchOrg, exitContext };
export type { OrganizationSummary };
